import { ComponentStyleConfig } from '@chakra-ui/react';

const BadgeTheme: ComponentStyleConfig = {
  baseStyle: {
    borderRadius: '5px',
    lineHeight: '19.5px',
    minHeight: '20px',
    minWidth: '20px',
    textAlign: 'center',
    fontSize: 'sm'
  },
  variants: {
    podium: {
      backgroundColor: 'red.dark',
      color: 'silver.lightest'
    }
  },
  defaultProps: {
    variant: 'podium',
    colorScheme: ''
  }
};

export default BadgeTheme;
